/* @flow */

import React from 'react';

import Link from 'depop/components/Link';

import { FAMILY_STANDARD_BOLD } from 'depop/styles/typography';

import { css } from 'glamor';

import qs from 'qs';

type Props = {
  source: string,
};

const KeywordToken = ({ source }: Props) =>
  <Link
    to={{
      pathname: '/search/',
      search: `?${qs.stringify({
        q: source,
      })}`,
    }}
    {...css({
      color: '#000',
      fontFamily: FAMILY_STANDARD_BOLD,
      textDecoration: 'none',
      fontWeight: 'bold',
      ':hover': {
        textDecoration: 'underline',
      },
    })}>
    {source}
  </Link>;

export default KeywordToken;



// WEBPACK FOOTER //
// ../src/client/components/UserText/KeywordToken.js